import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[dateMask]'
})
export class DateMaskDirective {
  private previousValue: string = '';

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent): void {
    const input = this.el.nativeElement.value;
    if (input.length > 10) {
      this.el.nativeElement.value = this.previousValue;
      return;
    }

    const newValue = this.formatDate(input);
    this.el.nativeElement.value = newValue;
    this.previousValue = newValue;
  }

  private formatDate(value: string): string {
    const digits = value.replace(/\D/g, '');
    const matched = digits.match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
    if (!matched) {
      return '';
    }

    let formatted = '';
    if (matched[1]) {
      formatted = matched[1];
    }
    if (matched[2]) {
      formatted += (formatted.length ? '/' : '') + matched[2];
    }
    if (matched[3]) {
      formatted += (formatted.length ? '/' : '') + matched[3];
    }

    return formatted;
  }

}
